import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { get } from "lodash";
import {
  loginUser,
  gotoPathOrDashboard
} from "../actions";

import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

import logo from "../assets/sf-logo-blue.png";

// Material UI
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import LockIcon from "@material-ui/icons/LockOutlined";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = theme => ({
  main: {
    width: "auto",
    display: "block", // Fix IE 11 issue.
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
    [theme.breakpoints.up(400 + theme.spacing(3 * 2))]: {
      width: 400,
      marginLeft: "auto",
      marginRight: "auto"
    }
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  submit: {
    marginTop: theme.spacing(3)
  }
});

class SignIn extends React.Component {
  state = {
    username: '',
    password: '',
    rememberMe: false,
  };

  componentDidMount() {
    if (this.props.isLoggedIn) {
      const { location } = this.props;
      this.props.gotoPathOrDashboard(get(location, 'state.from'));
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.isLoggedIn !== this.props.isLoggedIn && this.props.isLoggedIn) {
      const { location } = this.props;
      this.props.gotoPathOrDashboard(get(location, 'state.from'));
    }
  }

  onUsernameChange = e => this.setState({ username: e.target.value });
  onPasswordChange = e => this.setState({ password: e.target.value });

  handleSubmit = event => {
    const { username, password } = this.state;
    this.props.loginUser(username, password, this.state.rememberMe);
  };

  onRememberMeChange = e => {
    this.setState({ rememberMe: !this.state.rememberMe })
  };

  render() {
    const { classes, isLoggedIn } = this.props;
    const { rememberMe, username, password } = this.state;

    return (
      <main className={classes.main}>
        <CssBaseline/>
        <Paper className={classes.paper}>
          <div>
            <img src={logo} alt="EDF Store and Forecast Logo"/>
          </div>
          <Avatar className={classes.avatar}>
            <LockIcon/>
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>

          <ValidatorForm
            onSubmit={this.handleSubmit}
            onError={errors => console.log(errors)}
          >
            <FormControl margin="normal" required fullWidth>
              <TextValidator
                id="username"
                label="Username"
                onChange={this.onUsernameChange}
                name="username"
                value={username}
                validators={["required"]}
                errorMessages={["this field is required"]}
              />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <TextValidator
                id="password"
                type="password"
                label="Password"
                onChange={this.onPasswordChange}
                name="password"
                value={password}
                validators={["required"]}
                errorMessages={["this field is required"]}
              />
            </FormControl>
            <FormControlLabel
              control={<Checkbox value="remember" color="primary"/>}
              onChange={this.onRememberMeChange}
              checked={rememberMe}
              label="Remember me"
            />
            {/* <InputLabel htmlFor="username">Username</InputLabel>
            <Input
              id="username"
              name="username"
              autoComplete
              autoFocus
              onChange={this.onUsernameChange}
              value={this.props.auth.username}
            />
          </FormControl>
          <FormControl margin="normal" required fullWidth>
            <InputLabel htmlFor="password">Password</InputLabel>
            <Input
              name="password"
              type="password"
              id="password"
              autoComplete="current-password"
              onChange={this.onPasswordChange}
              value={this.props.auth.password}
            />
          </FormControl>
          <FormControlLabel
            control={<Checkbox value="remember" color="primary" />}
            label="Remember me"
          /> */}
            <Button
              id="signin-button"
              type="submit"
              fullWidth
              variant="contained"
              color={isLoggedIn !== false ? "primary" : "secondary"}
              className={classes.submit}
            >
              {isLoggedIn !== false
                ? "Sign in"
                : " Wrong User and/or Password"}
            </Button>
          </ValidatorForm>
        </Paper>
      </main>
    );
  }
}

SignIn.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    isLoggedIn: state.auth.isLoggedIn
  };
};

export default withRouter(withStyles(styles)(
  connect(
    mapStateToProps,
    { loginUser, gotoPathOrDashboard }
  )(SignIn))
);



// WEBPACK FOOTER //
// ./src/layout/SignIn.js